import React from "react";

const PurchaseOrderDetails = ({ RowData, isTablet }) => {
  return (
    <div className="col-md-8">
      
                      
     
    </div>
  );
};

export default PurchaseOrderDetails;
